<a
  class="categoria-servicos-card"
  [attr.data-categoria-servicos-cor]="categoria().cor"
  [routerLink]="'/' + categoria().rotaPagina"
>
  @if (tipos().length) {
    <ul class="categoria-servicos-card-tipos">
      @for (tipo of tipos(); track tipo.tipo) {
        <li class="categoria-servicos-card-tipo">
          <i-lucide [name]="tipo.icone" size="13" aria-hidden="true"></i-lucide>
          {{ tipo.rotulo }}
        </li>
      }
    </ul>
  }

  <app-icone-servico
    class="categoria-servicos-card-icone"
    [icone]="categoria().icone"
  ></app-icone-servico>

  <div class="categoria-servicos-card-conteudo">
    <h3 class="categoria-servicos-card-titulo">{{ categoria().titulo }}</h3>
    <p class="categoria-servicos-card-descricao">{{ categoria().descricao }}</p>
  </div>

  <i-lucide class="categoria-servicos-card-info" name="info" size="20" aria-hidden="true"></i-lucide>
</a>
